import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import classNames from 'classnames';
import {Button} from '@deviceinsight/ng-ui-basic-components';
import ElementTargetValues from './ElementTargetValues';
import {DeviceElement, RuleConditionState} from '../../../modules/ruleengine/types';
import {CompareOperator, EVENTS} from '../../../modules/ruleengine/config/consts';
import TranslatedOption from '../../common/TranslatedOption';
import {
	DATAPOINT_BUTTON1,
	DATAPOINT_BUTTON2,
	DATAPOINT_IS_ONLINE,
	DATAPOINT_LED,
	DATAPOINT_PIN1,
	DATAPOINT_PIN2,
	DATAPOINT_PIN3,
	DATAPOINT_PIN4
} from '../../../modules/common/consts';
type Props = {
	onElementTargetSelect: (arg0: Partial<RuleConditionState>) => void;
	onChangeCompareOperator: (arg0: CompareOperator) => void;
	currentConditionState: Partial<RuleConditionState>;
	element: DeviceElement;
	isTrigger: boolean;
	canEdit: boolean;
};
export default class ConditionElementTarget extends React.PureComponent<Props> {
	onTargetSelect = (targetName: string) => {
		const {onElementTargetSelect, element} = this.props;
		const elementTarget = element.dataTargets.find((dataTarget) => dataTarget.name === targetName);

		if (elementTarget) {
			switch (elementTarget.dataPoint) {
				case DATAPOINT_PIN1:
				case DATAPOINT_PIN2:
				case DATAPOINT_PIN3:
				case DATAPOINT_PIN4:
					onElementTargetSelect({
						elementTarget,
						status: true,
						frequency: 0
					});
					break;

				case DATAPOINT_BUTTON1:
				case DATAPOINT_BUTTON2:
				case DATAPOINT_LED:
					onElementTargetSelect({
						elementTarget,
						color: '#000000',
						frequency: 0
					});
					break;

				case EVENTS.button1Pressed:
				case EVENTS.button2Pressed:
					onElementTargetSelect({
						elementTarget,
						pressed: true
					});
					break;

				case DATAPOINT_IS_ONLINE:
					onElementTargetSelect({
						elementTarget,
						online: true
					});
					break;

				default:
					onElementTargetSelect({
						elementTarget
					});
			}
		}
	};
	onChangeAttribute = (attributeValues: Partial<RuleConditionState>) => {
		const {onElementTargetSelect} = this.props;
		onElementTargetSelect({...attributeValues});
	};

	render() {
		const {currentConditionState, isTrigger, element, onChangeCompareOperator, canEdit} = this.props;
		const {elementTarget, compareOperator} = currentConditionState;
		const selectableTargets = isTrigger
			? element.dataTargets
			: element.dataTargets.filter((target) => target.availableForCondition);
		const selectedTargetKey = elementTarget ? elementTarget.name : undefined;
		const isNegated = compareOperator === CompareOperator.not ? true : false;
		const buttonClass = classNames({
			compare_button: true,
			negated: isNegated
		});

		return (
			<div className="rule-target">
				<select
					data-testid="select-target-dropdown"
					onChange={({target: {value}}) => this.onTargetSelect(value)}
					value={selectedTargetKey || ''}
					className="select-target"
					disabled={!canEdit}>
					{!selectedTargetKey && (
						<TranslatedOption
							trans={{
								id: `ruleengine.element.select.property`,
								defaultValue: `Please select...`
							}}
							value=""
							key="initial-selection"
						/>
					)}
					{selectableTargets.map((target, index) => (
						<TranslatedOption
							key={`${target.name}_${index}`}
							trans={{
								id: `${target.labelId}`,
								defaultValue: `${target.defaultLabel}`
							}}
							value={target.name}
						/>
					))}
				</select>

				{!isTrigger && elementTarget && (
					<span className={buttonClass}>
						<Button
							naked
							onClick={() =>
								onChangeCompareOperator(isNegated ? CompareOperator.equal : CompareOperator.not)
							}
							disabled={!canEdit}>
							{isNegated ? (
								<Trans i18nKey="ruleengine.condition.compare.not">NOT</Trans>
							) : (
								<Trans i18nKey="ruleengine.condition.compare.equal">EQUAL</Trans>
							)}
						</Button>
					</span>
				)}
				{elementTarget && (
					<ElementTargetValues
						data-testid="element-target-value"
						currentConditionState={currentConditionState}
						elementTarget={elementTarget}
						canEdit={canEdit}
						onChange={this.onChangeAttribute}
					/>
				)}
			</div>
		);
	}
}
